import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {RequestTypeModel} from '../../models/request-type.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SUPPORTED_REQUEST_TYPES, REQUEST_TYPE} from '../../constants/request-types.constant';
import {EnvService} from '../../../env.service';

@Component({
  selector: 'app-new-request',
  templateUrl: './new-request.component.html',
  styleUrls: ['./new-request.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NewRequestComponent implements OnInit {

  public items: RequestTypeModel[] = [];

  constructor(private dialogRef: MatDialogRef<NewRequestComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              public env: EnvService) {
    this.items = data.requestTypes;
  }

  ngOnInit(): void {
    this.roundDuration();
  }

  public selectRequestType(item: RequestTypeModel): void {
    if (SUPPORTED_REQUEST_TYPES.indexOf(item.type) !== -1) {
      this.dialogRef.close(item);
    }
  }

  public isItemDisabled(type: string): boolean {
    return SUPPORTED_REQUEST_TYPES.indexOf(type) === -1;
  }

  private roundDuration(): void {
    this.items.forEach(item => {
      let expectedDurationWeeks = Math.round(item.expectedDurationDays / 7);
      if(item.type === REQUEST_TYPE.IR) {
        expectedDurationWeeks = 2;
      }
      item.expectedDurationWeeks = expectedDurationWeeks;
    });
  }

}
